import { IUser } from "../../user/IUser";
import { IBot } from "./IBot";

export const FolderType:string="ai_folder"


export interface IFolder {
    id: string;
    parent_id:string|undefined;
    user:IUser, 
    name: string;

    type: string;
    version: number;

    folders?: IFolder[]
    bots?: IBot[]
    use_bots?: IBot[]
    ctx?: {[key:string]:any} 
    selected?:boolean
    prompt?: string
    system?:boolean
    expandedIndex?:number
  }